module.exports = (RESTService) ->
  'ngInject'
  RESTService.setFullResponse(true).service('admin/product_brands')
